import React from 'react';
import { useIntl } from 'react-intl';
import { useRouter } from 'next/router';
import withApollo from '../lib/apollo';
import profilesConnectionQuery
  from '../lib/queries/products/profilesConnectionQuery.graphql';
import { DirectoryPage, DirectoryLayout } from '../components/DirectoryPage';
import DirectoryList from '../components/DirectoryPage/List';
import messages from '../lib/messages.json';
import redirectRouteToDomain from '../lib/redirectRouteToDomain';
import {
  directoryCardImageConfigurations,
  directoryCardLogoConfigurations,
} from '../lib/imageConfigurations';

const headerImageUrls = {
  mobile: [
    'https://r.fashionunited.com/dPKYBxh2TPdLORlP49Ce8Cv-yGEdamagUHVY3POIBxk/resize:fill:42:34:0/gravity:ce/quality:10/aHR0cHM6Ly9mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvZmFzaGlvbl9zY2hvb2xzX2RpcmVjdG9yeV9iYW5uZXJfbW9iaWxlLmpwZw',
    'https://r.fashionunited.com/oNpO8OJMVKZNUCcYC2oA4suF-lsG9c36xIDekzr3K6U/resize:fill:360:288:0/gravity:ce/quality:70/aHR0cHM6Ly9mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvZmFzaGlvbl9zY2hvb2xzX2RpcmVjdG9yeV9iYW5uZXJfbW9iaWxlLmpwZw',
    'https://r.fashionunited.com/NDBOSxFqwL1qrJQ1hHYKqoDRQKWgWn8zrYqAqQ8lldc/resize:fill:720:576:0/gravity:ce/quality:70/aHR0cHM6Ly9mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvZmFzaGlvbl9zY2hvb2xzX2RpcmVjdG9yeV9iYW5uZXJfbW9iaWxlLmpwZw',
  ],
  desktop: [
    'https://r.fashionunited.com/X9qhb_B-ALPo8FpcpRyqaIFLgvjUiklIsRwObp8Acnc/resize:fill:42:8:0/gravity:ce/quality:10/aHR0cHM6Ly9mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvZmFzaGlvbl9zY2hvb2xzX2RpcmVjdG9yeV9iYW5uZXJfZGVza3RvcC5qcGc',
    'https://r.fashionunited.com/5mzFwPxLBXqjS9JcV5YHe7ZNTxp8K5VAxxyuToGj-58/resize:fill:1350:277:0/gravity:ce/quality:70/aHR0cHM6Ly9mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvZmFzaGlvbl9zY2hvb2xzX2RpcmVjdG9yeV9iYW5uZXJfZGVza3RvcC5qcGc',
    'https://r.fashionunited.com/N7fDaqVQZF74jBs18i17g8KPzZd72c4mY50souoTbA0/resize:fill:2560:526:0/gravity:ce/quality:70/aHR0cHM6Ly9mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvZmFzaGlvbl9zY2hvb2xzX2RpcmVjdG9yeV9iYW5uZXJfZGVza3RvcC5qcGc',
    'https://r.fashionunited.com/jWCC-yeqZbOGinoB6fJtIuEBiGJJ57pfuvdlozMwG1k/resize:fill:5120:1052:0/gravity:ce/quality:70/aHR0cHM6Ly9mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvZmFzaGlvbl9zY2hvb2xzX2RpcmVjdG9yeV9iYW5uZXJfZGVza3RvcC5qcGc',
  ],
};

export const SchoolsDirectoryPage = () => {
  const intl = useIntl();
  const {
    query: {
      country,
      section,
      search,
    },
  } = useRouter();

  const SCHOOLSLIMIT = 20;

  return (
    <DirectoryPage
      title={intl.formatMessage(messages['schools-directory.title'])}
      route="schools-directory"
      pageType="schools"
      ComponentWithQuery={DirectoryList}
      variables={{
        type: 'SCHOOL',
        first: SCHOOLSLIMIT,
        search,
        premium: section !== 'all' || null,
        country: country || null,
        imageConfigurations: directoryCardImageConfigurations,
        logoConfigurations: directoryCardLogoConfigurations,
      }}
      query={profilesConnectionQuery}
    />
  );
};

SchoolsDirectoryPage.getLayout = (page) => (
  <DirectoryLayout
    imageUrls={headerImageUrls}
    alt="FashionUnited Schools Directory"
  >
    {page}
  </DirectoryLayout>
);

SchoolsDirectoryPage.getInitialProps = redirectRouteToDomain(
  'schools-directory',
);

export default withApollo(SchoolsDirectoryPage);
